import React from 'react';

/**
 * Component representing the answer section of an FAQ.
 *
 * @component
 * @param {React.PropsWithChildren} props - The component props.
 * @returns {JSX.Element} The rendered Answer component.
 */
const Answer: React.FC<
  React.PropsWithChildren & React.HTMLAttributes<HTMLDivElement>
> = ({ children, ...props }) => (
  <div className="mb-32 text-secondary" {...props}>
    {children}
  </div>
);

export default Answer;
